const Franchises = () => import('@/modules/franchises');

export default [
  {
    path: '/',
    name: 'root',
    redirect: '/franquias',
  },
  {
    path: '/franquias/criar',
    name: 'franchises-create',
    component: Franchises,
    props: true,
    meta: {
      navbarTitle: 'Criar franquia',
    },
  },
  {
    path: '/franquias',
    name: 'list-franchises',
    component: Franchises,
    props: true,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Franquias',
      menuData: {
        title: 'Franquias',
        id: 'franchisesSidebar',
        section: 'Operação',
        icon: 'briefcase',
      },
    },
  },
];
